import * as React from 'react';
import { Carousel as LibCarousel } from 'react-responsive-carousel';
import classNames from 'classnames';
import CustomIndicator from './components/CustomIndicator';
import CustomButton from './components/CustomButton';

import styles from './Carousel.module.scss';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

export interface Props {
  className?: string;
  children?: React.ReactChild[] &
    (
      | boolean
      | React.ReactChild
      | React.ReactFragment
      | React.ReactPortal
      | null
    );
  infiniteLoop?: boolean;
  showStatus?: boolean;
  autoPlay?: boolean;
  renderIndicator?: (
    clickHandler: React.MouseEventHandler<HTMLButtonElement> | undefined,
    isActive: boolean,
  ) => React.ReactNode;
  renderArrowNext?: (
    clickHandler: React.MouseEventHandler<HTMLButtonElement> | undefined,
  ) => React.ReactNode;
  renderArrowPrev?: (
    clickHandler: React.MouseEventHandler<HTMLButtonElement> | undefined,
  ) => React.ReactNode;
  centerMode?: boolean;
  centerSlidePercentage?: number;
}

const Carousel: React.FunctionComponent<Props> = ({
  className,
  autoPlay,
  children,
  infiniteLoop = true,
  showStatus = false,
  renderIndicator = (clickHandler, isActive) => (
    <CustomIndicator isActive={isActive} clickHandler={clickHandler} />
  ),
  renderArrowNext = (clickHandler) => (
    <CustomButton clickHandler={clickHandler} direction="next" />
  ),
  renderArrowPrev = (clickHandler) => (
    <CustomButton clickHandler={clickHandler} direction="prev" />
  ),
  centerMode = false,
  centerSlidePercentage = 80,
}) => (
  <LibCarousel
    className={classNames(styles.wrapper, className)}
    autoPlay={autoPlay}
    infiniteLoop={infiniteLoop}
    showStatus={showStatus}
    renderIndicator={renderIndicator}
    renderArrowNext={renderArrowNext}
    renderArrowPrev={renderArrowPrev}
    centerMode={centerMode}
    centerSlidePercentage={centerSlidePercentage}
  >
    {children}
  </LibCarousel>
);

export default Carousel;
